<template>
  <div class="C404">
    <div class="container-404" style="text-align: center;">
      <p class="hero__title-404">Oops...!</p>
      <img src="@/assets/IMGS/SVG/404.svg" alt="404" class="img__404">
      <p class="hero__title-404">Страница не найдена</p>
      <a href="/" class="page-404__btn btn-reset btn btn_blue">Вернуться на главную</a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'NotFound',
    data() {
      return {};
    },
    mounted() {
      try {
        this.$parent.$parent.setSubHeaderTitle('Страница не найдена')
      }catch(error) {
        return
      }
    }
}
</script> 

<style lang="css" scoped src="@/assets/css/notfound.css"></style>